import React from "react";
import { UserProvider } from "./context/UserContext";
import Settings from "./Components/Settings/Settings.jsx";

function App() {
  return (
    <UserProvider>
      <Settings />
    </UserProvider>
  );
}

export default App;
